import Api from 'utils/api'

export const postCopyInterviewTemplate = ({ title, department, uuid }) =>
  Api.post(['interviewtemplates', uuid, 'copy'], { title, department })

export const postInterviewTemplate = payload =>
  Api.post(['interviewtemplates'], payload)

export const fetchInterviewTemplate = ({ uuid }) =>
  Api.get(['interviewtemplates', uuid])

export const fetchInterviewTemplateByUUID = ({ uuid }) =>
  Api.get(['interviewtemplateaspdf', uuid])

export const fetchInterviewTemplates = ({
  department,
  limit,
  offset,
  ordering,
  search,
}) =>
  Api.get(['interviewtemplates'], {
    department,
    limit,
    offset,
    ordering,
    search,
  })

export const updateInterviewTemplate = ({ title, uuid }) =>
  Api.patch(['interviewtemplates', uuid], { title })

export const deleteInterviewTemplateQuestion = ({ uuid }) =>
  Api.delete(['interviewquestions', uuid])

export const postInterviewTemplateQuestion = ({
  description,
  order,
  section,
  title,
}) => Api.post(['interviewquestions'], { description, order, section, title })

export const updateInterviewTemplateQuestion = ({
  description,
  order,
  title,
  uuid,
}) => Api.patch(['interviewquestions', uuid], { description, order, title })

export const deleteInterviewTemplateSection = ({ uuid }) =>
  Api.delete(['interviewsections', uuid])

export const postInterviewTemplateSection = ({
  description,
  interviewTemplate,
  key,
  order,
  scoreable,
  title,
}) =>
  Api.post(['interviewsections'], {
    description,
    interview_template: interviewTemplate,
    key,
    order,
    scoreable,
    title,
  })

export const updateInterviewTemplateSection = ({
  key,
  order,
  scoreable,
  title,
  uuid,
}) => Api.patch(['interviewsections', uuid], { key, order, scoreable, title })
